class FeatureConstants {
    static Survey = "Survey";
  }
  export default FeatureConstants;
  